import type { ChatLibContext } from '@repo/common/types/Chat';

let currentContext: ChatLibContext | null = null;

export const getChatLibContext = (): ChatLibContext => {
  if (!currentContext) {
    throw new Error('ChatLib context not initialized. Call initializeChatService() first.');
  }
  return currentContext;
};

export const setChatLibContext = (context: ChatLibContext | null): void => {
  currentContext = context;
};
